/**
 * Core: Mint Plugins
 * -----------------------------------------------------------------------------
 * - Global plugins for the Vue instances.
 */
import { formatMoney } from '@shopify/theme-currency'

export default {
  install: (app) => {

    /**
     * Formats money into universal store format.
     * @param {Number} value - Value in cents.
     * @param {String} format - Shopify money format.
     * @returns {String}
     */
    app.config.globalProperties.$formatMoney = (value, format = mint.shop.moneyFormat) => {
      return formatMoney(value, format)
    }

    // /**
    //  * Get a variable from the `window.mint` object into the app.
    //  * @example
    //  *  <p v-text="$mint(shop.url)" />
    //  *  will output: `window.mint.shop.url`
    //  *
    //  * @param {String} path - Path to window variable stored in theme-js-variables.liquid.
    //  * @returns {*}
    //  */
    // app.config.globalProperties.$mint = (path) => {
    //   let variable = window.mint

    //   path.split('.').forEach((part) => {
    //     variable = variable[part]
    //   })

    //   return variable
    // }

    // /**
    //  * Return a locale from the Shopify theme strings.
    //  * @param {String} path - Path to locale defined in `theme-strings.liquid`.
    //  * @param {Object} [options] - Additional function operations.
    //  * @param {Object} [options.replace] - Liquid instances to replace in the locale.
    //  * @returns {String}
    //  */
    // app.config.globalProperties.$string = (path, { replace }) => {
    //   return 'foo'
    // }
  },
}
